import classes from "./review.module.css";
import Timer from "../../../assets/images/Onboarding/timer.svg";
import { BlueButton, YellowButton } from "../../../components/UI/Button/button";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context";
import { talentProfile } from "../../../services/talentCalls";
import { errorHandler } from "../../../utils";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const TalentReview = () => {
  const { setData } = useContext(UserContext);
  let navigate = useNavigate();
  const [time, setTime] = useState({
    sec: undefined,
    min: undefined,
    hours: undefined,
  });
  const [loading, setLoading] = useState(false);

  const currentTime = new Date().getTime();
  let countDownDate = +currentTime + 86400000;

  let calcTime = () => {
    setInterval(function () {
      const newTime = new Date().getTime();
      let distance = countDownDate - +newTime;
      setTime((prevState) => ({
        ...prevState,
        sec: Math.floor((distance % (1000 * 60)) / 1000),
        min: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
      }));
    }, 1000);
  };

  const fetchProfile = async () => {
    setLoading(true)
    try {
      const res = await talentProfile();

      setData(res?.data?.data?.talent);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
          "Network error: Something went wrong, Please check your internet connection and try again.",
          "Error"
        );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProfile();

    // Safely check if gtag exists on the window object
    if (typeof window !== 'undefined' && window.gtag) {
      // GA4 is configured site-wide in public/index.html.
      // Fire the completion event (safeguarded against page refreshes)
      if (!sessionStorage.getItem('onboarding_complete_fired')) {
        window.gtag('event', 'onboarding_complete', {
          'event_category': 'onboarding',
          'event_label': 'talent_onboarding_stage_8'
        });
        sessionStorage.setItem('onboarding_complete_fired', 'true');
      }
    }
  }, []);

  useEffect(() => {
    calcTime();
  }, []);

  const move = (e) => {
    e.preventDefault();
    navigate("/job-feed");
  };
  return (
    <>
      {loading && <FullScreenLoader />}
      <div className={`${classes.parent} py-8`}>
        <img src={Timer} alt="countdown" />
        <span className={`center mt-md ${classes.time}`}>
          {time.hours} : {time.min} : {time.sec}
        </span>
        <div className={`flex center-flex mb-md ${classes.label}`}>
          <span>Hrs</span>
          <span>Mins</span>
          <span>Sec</span>
        </div>
      <p className="center !w-full max-w-[660px] !leading-snug mb-8 rounded-xl p-6 bg-[#f0f0f0] text-xl font-light">
        Now we just have to verify in not more than 24 - 48 hours.<br/> <br/>
        We strongly advise you take your psychometric tests, as that will give you a better chance of getting matched to a job
      </p>
        <div className="flex items-center justify-center gap-2 sm:!gap-10">
          <BlueButton onClick={() => navigate("/test")} className="!w-full !max-w-fit !mx-0" >
            Take your Tests
          </BlueButton>
          <YellowButton extra={classes.yellowBtn} onClick={move} className="!mx-0">Finish</YellowButton>
        </div>
      </div>
    </>
  );
};

export default TalentReview;
